import { API_BASE } from '@/shared/services/api';
import React, { useState } from "react";
import axios from "axios";
import { SlideShell } from "../../../shared/components/SlideShell";
import { toast } from "sonner";

const IMG = "https://images.unsplash.com/photo-1483729558449-99ef09a8c325";
const BACKEND_URL = API_BASE;
const API = `${BACKEND_URL}/api`;

export const Slide10 = ({ t, total, onActive, lang }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("user");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim()) return;
    setLoading(true);
    try {
      await axios.post(`${API}/leads`, {
        name: name.trim(),
        email: email.trim(),
        role,
        language: lang,
      });
      setDone(true);
      toast.success(t.labels.success);
    } catch (err) {
      const status = err?.response?.status;
      if (status === 409) {
        toast.error(t.labels.duplicate);
      } else {
        toast.error(t.labels.error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <SlideShell index={9} total={total} onActive={onActive} label="Vision · Waitlist">
      <div
        className="absolute inset-0 opacity-50"
        style={{
          backgroundImage: `url(${IMG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/30" />
      <div className="absolute inset-0 radial-gold opacity-50" />

      <div className="relative z-10 w-full max-w-7xl px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <div className="overline mb-6">{t.overline}</div>
            <h2 className="font-display font-medium text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tighter">
              {t.heading}
            </h2>
            <p className="mt-8 text-lg md:text-xl text-neutral-300 font-light leading-relaxed max-w-lg">
              {t.body}
            </p>

            <div className="accent-line my-10 max-w-xs" />

            <div className="font-mono text-xs tracking-widest text-neutral-500">
              BRAZILIANREWARDS · 2026
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="relative">
              <div className="absolute -inset-3 bg-[var(--ph-accent-glow)] blur-3xl opacity-50" />
              <div className="relative glass-strong rounded-3xl p-8 md:p-10 gold-glow">
                {!done ? (
                  <>
                    <div className="font-display text-3xl md:text-4xl mb-2">
                      {t.formTitle}
                    </div>
                    <div className="text-sm text-neutral-400 mb-8">
                      {t.formSub}
                    </div>

                    <form onSubmit={submit} className="space-y-5" data-testid="waitlist-form">
                      <div>
                        <label className="font-mono text-[10px] tracking-widest text-neutral-500 block mb-2">
                          {t.labels.name.toUpperCase()}
                        </label>
                        <input
                          type="text"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          required
                          maxLength={120}
                          className="dark-input w-full px-4 py-3 rounded-lg text-base"
                          data-testid="waitlist-name"
                          placeholder={t.labels.name}
                        />
                      </div>

                      <div>
                        <label className="font-mono text-[10px] tracking-widest text-neutral-500 block mb-2">
                          {t.labels.email.toUpperCase()}
                        </label>
                        <input
                          type="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                          className="dark-input w-full px-4 py-3 rounded-lg text-base"
                          data-testid="waitlist-email"
                          placeholder="hello@example.com"
                        />
                      </div>

                      <div>
                        <label className="font-mono text-[10px] tracking-widest text-neutral-500 block mb-3">
                          {t.labels.role.toUpperCase()}
                        </label>
                        <div className="grid grid-cols-2 gap-3">
                          <button
                            type="button"
                            onClick={() => setRole("user")}
                            data-testid="waitlist-role-user"
                            className={`px-4 py-3 rounded-lg text-sm transition-all ${
                              role === "user"
                                ? "bg-[var(--ph-accent)] text-black border border-[var(--ph-accent)]"
                                : "dark-input"
                            }`}
                          >
                            {t.labels.user}
                          </button>
                          <button
                            type="button"
                            onClick={() => setRole("business")}
                            data-testid="waitlist-role-business"
                            className={`px-4 py-3 rounded-lg text-sm transition-all ${
                              role === "business"
                                ? "bg-[var(--ph-accent)] text-black border border-[var(--ph-accent)]"
                                : "dark-input"
                            }`}
                          >
                            {t.labels.business}
                          </button>
                        </div>
                      </div>

                      <button
                        type="submit"
                        disabled={loading}
                        data-testid="waitlist-submit"
                        className="w-full mt-2 bg-[var(--ph-accent)] hover:bg-[var(--ph-accent-hover)] text-black font-medium py-4 rounded-lg transition-colors disabled:opacity-60 flex items-center justify-center gap-2"
                      >
                        {loading ? t.labels.sending : t.labels.submit}
                        {!loading && <span className="text-lg">→</span>}
                      </button>
                    </form>
                  </>
                ) : (
                  <div
                    className="text-center py-8"
                    data-testid="waitlist-success"
                  >
                    <div className="mx-auto w-14 h-14 rounded-full bg-[var(--ph-accent)] text-black flex items-center justify-center font-display text-2xl mb-6 animate-pop">
                      ✓
                    </div>
                    <div className="font-display text-3xl mb-3">
                      {t.labels.success}
                    </div>
                    <div className="font-mono text-xs tracking-widest text-neutral-500">
                      WELCOME · BEM-VINDO
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </SlideShell>
  );
};


